import { render, staticRenderFns } from "./list-v-cover-summary.vue?vue&type=template&id=505a7654&scoped=true"
import script from "./list-v-cover-summary.vue?vue&type=script&lang=js"
export * from "./list-v-cover-summary.vue?vue&type=script&lang=js"
import style0 from "./list-v-cover-summary.vue?vue&type=style&index=0&id=505a7654&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505a7654",
  null
  
)

export default component.exports